<footer class="footer container-fluid row pt-2 pb-0">
  <div class="col-md-12 text-center">
    <ul class="mb-0">
      <li> &copy; {{footerText}} Version : {{buildInfo}}</li>
    </ul>
  </div>
</footer>
